import { combineEpics } from "redux-observable";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { createAnalysisStudyActionTypes, creatingAnalysisStudy, createdAnalysisStudy, afterCreateAnalysisStudy, afterCreateAnalysisStudyActionTypes, loadAnalysisSegmentsActionTypes, loadingSegmentData, loadedSegmentData, uploadSupportFilesActionTypes, uploadingSupportFiles, uploadedSupportFiles, sampleForayJobConfigActionTypes, loadingSampleForayJobConfig, loadedSampleForayJobConfig, validateForayConfig, validateForayJobConfigActionTypes, validatingForayConfig, validatedForayConfig, loadAnalysisStepPropertiesEpicReducer, loadAnalysisConfigEpicReducer, loadJobExecMetaEpicReducer, loadAnalysisRequestFormEpicReducer, loadMetricSetsEpicReducer, loadMetricSetVersionEpicReducer, loadRawStudyEpicReducer, loadForayConfigMetadataEpicReducer, loadAnalysisTemplateV2EpicReducer, loadAnalysisTemplateFromVersionEpicReducer, loadAnalysisTemplateNamesFromVersionEpicReducer } from "./AnalysisCreateContainer.ducks.js";
import { of, merge } from "rxjs";
import { getCompletedAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import AnalysisResources from "../../../module/AnalysisResources.js";
import MetricServiceResource from "@ane/exp-data/lib/resources/MetricServiceResource";
import { d as convertToAnalysisCreateV2, e as getMetricSetVersionNameFromVersionId, s as segmentDictionaryKey, f as createForayJobValidationRequest } from "../../../../../../AnalysisFormUtils-724038a8.js";
import { SupportFileType } from "../SupportFilesTab/SupportFilesForm.utils.js";
import ForayRunnerResources from "../../../module/ForayRunnerResources.js";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { AnalysisRouteUtils } from "@ane/exp-data/lib/routes/AnalysisRoute.utils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { SetSubscribersEpicReducer } from "@ane/exp-ux/lib/components/Subscribers/SetSubscribers.epics";
import { ENTITY_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import logger from "@ane/core/lib/services/logging/Logger";
import { MAUI_METRIC_LOG, previewScorecardLogProperties } from "@ane/exp-data/lib/constants/maui.constants";
const createAnalysisStudyEpic = produceLoadLoadingLoadedEpic({
  filterOnType: createAnalysisStudyActionTypes.LOAD,
  loadResource: (payload) => AnalysisResourceV2.createAnalysis(payload.workspaceId || "", convertToAnalysisCreateV2(payload.analysisCreateRequest || {})),
  loadingAction: (payload) => creatingAnalysisStudy(),
  loadedAction: (successData, payload, error) => {
    var _a, _b, _c;
    return of(
      createdAnalysisStudy(getCompletedAsyncWrapperObj((_a = successData == null ? void 0 : successData.value) == null ? void 0 : _a.id, error || "")),
      afterCreateAnalysisStudy(
        (_b = payload.analysisCreateRequest) != null ? _b : {},
        (_c = successData == null ? void 0 : successData.value) == null ? void 0 : _c.id,
        payload.subscribers || [],
        payload.workspaceId || "",
        error
      )
    );
  }
});
const afterCreateAnalysisStudyEpic = produceLoadLoadingLoadedEpic({
  filterOnType: afterCreateAnalysisStudyActionTypes,
  loadResource: (payload) => {
    return Promise.resolve();
  },
  loadingAction: (payload) => ({ type: "" }),
  loadedAction: (successData, payload, errors, errorContext, state) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const { error, subscribers, studyId, workspaceId, analysisCreateRequest } = payload;
    const stepId = (analysisCreateRequest == null ? void 0 : analysisCreateRequest.ExpStepId) || "";
    let actionsToDispatch = [];
    if (EnvironmentService.enableAnalysisCreateSubscriberComponent() && !error && !!subscribers && !!studyId && !!workspaceId) {
      const setSubscribersAction = SetSubscribersEpicReducer.actionCreators.load({
        workspaceId,
        entityType: ENTITY_TYPES.ANALYSIS,
        entityExternalId: studyId,
        entityIsNew: true,
        subscriberBaseInfoList: (subscribers == null ? void 0 : subscribers.map(
          (s) => !!s.id ? { id: s.id, type: s.type, tenantId: s.tenantId } : { id: s.primaryText, type: "Email", tenantId: s.tenantId }
        )) || []
      });
      actionsToDispatch.push(of(setSubscribersAction));
    }
    if (!!error) {
      logger.trackMetric({
        name: MAUI_METRIC_LOG.ANALYSIS_CREATE_ERROR,
        average: 1,
        properties: {
          [previewScorecardLogProperties.experimentStepId]: stepId,
          [previewScorecardLogProperties.templateName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisTemplateName,
          [previewScorecardLogProperties.studyName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisStudyName,
          [previewScorecardLogProperties.studyDescription]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisStudyDescription,
          [previewScorecardLogProperties.metricSetName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSet,
          [previewScorecardLogProperties.metricSetVersion]: getMetricSetVersionNameFromVersionId(
            (_c = (_b = state == null ? void 0 : state.analysisCreate.metricSetVersionDictAsync) == null ? void 0 : _b[(_a = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSet) != null ? _a : ""]) == null ? void 0 : _c.data,
            (_d = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSetVersion) != null ? _d : ""
          ),
          [previewScorecardLogProperties.metricSetVersionId]: (_e = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSetVersion) != null ? _e : "",
          [previewScorecardLogProperties.isPreviewScorecard]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.IsPreviewScorecard,
          [previewScorecardLogProperties.studyId]: studyId,
          [previewScorecardLogProperties.analysisCreateErrorMessage]: error
        }
      });
    } else if (!error && !!stepId) {
      logger.trackMetric({
        name: MAUI_METRIC_LOG.ANALYSIS_CREATED,
        average: 1,
        properties: {
          [previewScorecardLogProperties.experimentStepId]: stepId,
          [previewScorecardLogProperties.templateName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisTemplateName,
          [previewScorecardLogProperties.studyName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisStudyName,
          [previewScorecardLogProperties.studyDescription]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.AnalysisStudyDescription,
          [previewScorecardLogProperties.metricSetName]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSet,
          [previewScorecardLogProperties.metricSetVersion]: getMetricSetVersionNameFromVersionId(
            (_h = (_g = state == null ? void 0 : state.analysisCreate.metricSetVersionDictAsync) == null ? void 0 : _g[(_f = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSet) != null ? _f : ""]) == null ? void 0 : _h.data,
            (_i = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSetVersion) != null ? _i : ""
          ),
          [previewScorecardLogProperties.metricSetVersionId]: (_j = analysisCreateRequest == null ? void 0 : analysisCreateRequest.MetricSetVersion) != null ? _j : "",
          [previewScorecardLogProperties.isPreviewScorecard]: analysisCreateRequest == null ? void 0 : analysisCreateRequest.IsPreviewScorecard,
          [previewScorecardLogProperties.studyId]: studyId
        }
      });
      NavigationService.navigateTo(
        AnalysisRouteUtils.routes.view.url({
          stepId
        })
      );
    }
    actionsToDispatch.push(of({ type: "" }));
    return merge(...actionsToDispatch);
  }
});
const getSegmentsEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadAnalysisSegmentsActionTypes.LOAD,
  dontLoad: (payload, reducerState) => {
    var _a, _b, _c, _d, _e;
    return !!((_a = reducerState == null ? void 0 : reducerState.analysisCreate) == null ? void 0 : _a.segmentsDictAsync) && !!payload.metricSetName && (!!((_c = (_b = reducerState.analysisCreate) == null ? void 0 : _b.segmentsDictAsync[segmentDictionaryKey(payload.metricSetName, payload.metricSetVersion)]) == null ? void 0 : _c.data) || ((_e = (_d = reducerState.analysisCreate) == null ? void 0 : _d.segmentsDictAsync[segmentDictionaryKey(payload.metricSetName, payload.metricSetVersion)]) == null ? void 0 : _e.status) === AsyncRequestStatus.Pending);
  },
  loadResource: (payload) => {
    var _a, _b;
    return MetricServiceResource.getMetricSetSegments(
      payload.metricSetName || "",
      (_a = payload.metricSetVersion) != null ? _a : "",
      (_b = payload.workspaceId) != null ? _b : ""
    );
  },
  loadingAction: (payload) => loadingSegmentData({
    metricSetName: payload.metricSetName || "",
    metricSetVersion: payload.metricSetVersion || "",
    metricSetVersionSelected: payload.metricSetVersionSelected || "",
    workspaceId: payload.workspaceId || ""
  }),
  loadedAction: (successData, payload, error) => {
    return of(
      loadedSegmentData(
        {
          metricSetName: payload.metricSetName || "",
          metricSetVersion: payload.metricSetVersion || "",
          metricSetVersionSelected: payload.metricSetVersionSelected || "",
          workspaceId: payload.workspaceId || ""
        },
        getCompletedAsyncWrapperObj(successData, error || "")
      )
    );
  }
});
const uploadSupportFilesEpic = produceLoadLoadingLoadedEpic({
  filterOnType: uploadSupportFilesActionTypes.LOAD,
  loadResource: (payload, state) => {
    var _a, _b;
    const filesToUpload = payload.supportedFiles;
    const supportedFileType = payload.supportFileType;
    const filesInState = supportedFileType === SupportFileType.ScopeResource ? (_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.scopeResourcesSupportedFiles : (_b = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _b.scopeReferencesSupportedFiles;
    const remainingFilesToUpload = (filesToUpload == null ? void 0 : filesToUpload.filter((f) => !filesInState || !filesInState[f.name])) || [];
    return AnalysisResourceV2.uploadSupportFiles(
      payload.workspaceId,
      payload.stepId,
      remainingFilesToUpload
    );
  },
  loadingAction: (payload) => {
    const filesToUpload = payload.supportedFiles;
    const result = {};
    filesToUpload == null ? void 0 : filesToUpload.forEach((f) => result[f.name] = { data: f.name, status: AsyncRequestStatus.Pending, error: "" });
    return uploadingSupportFiles(payload.supportFileType || SupportFileType.ScopeResource, result);
  },
  loadedAction: (successData, payload, error) => {
    const filesToUpload = payload.supportedFiles;
    const result = {};
    filesToUpload == null ? void 0 : filesToUpload.forEach((f) => result[f.name] = getCompletedAsyncWrapperObj(f.name, error || ""));
    return of(uploadedSupportFiles(payload.supportFileType || SupportFileType.ScopeResource, result));
  }
});
const getSampleForayJobConfigEpic = produceLoadLoadingLoadedEpic({
  filterOnType: sampleForayJobConfigActionTypes.LOAD,
  loadResource: (payload, state) => {
    return AnalysisResources.getSampleForayJobConfig(payload.analysisCreateRequest || {});
  },
  loadingAction: (payload) => {
    return loadingSampleForayJobConfig();
  },
  loadedAction: (successData, payload, error) => {
    const forayValidationRequest = createForayJobValidationRequest(successData, payload.formValues);
    return of(
      loadedSampleForayJobConfig(getCompletedAsyncWrapperObj(successData, error)),
      validateForayConfig(forayValidationRequest)
    );
  }
});
const validateForayJobConfigEpic = produceLoadLoadingLoadedEpic({
  filterOnType: validateForayJobConfigActionTypes.LOAD,
  loadResource: (payload, state) => {
    return ForayRunnerResources.validateForayJobConfig(payload.forayValidationRequest);
  },
  loadingAction: (payload) => {
    return validatingForayConfig();
  },
  loadedAction: (successData, payload, error) => {
    return of(validatedForayConfig(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const AnalysisCreateContainerEpic = combineEpics(
  loadAnalysisStepPropertiesEpicReducer.epic,
  loadAnalysisConfigEpicReducer.epic,
  loadJobExecMetaEpicReducer.epic,
  loadAnalysisRequestFormEpicReducer.epic,
  loadMetricSetsEpicReducer.epic,
  createAnalysisStudyEpic,
  loadMetricSetVersionEpicReducer.epic,
  getSegmentsEpic,
  uploadSupportFilesEpic,
  getSampleForayJobConfigEpic,
  validateForayJobConfigEpic,
  afterCreateAnalysisStudyEpic,
  loadRawStudyEpicReducer.epic,
  loadForayConfigMetadataEpicReducer.epic,
  loadAnalysisTemplateV2EpicReducer.epic,
  loadAnalysisTemplateFromVersionEpicReducer.epic,
  loadAnalysisTemplateNamesFromVersionEpicReducer.epic
);
export {
  afterCreateAnalysisStudyEpic,
  createAnalysisStudyEpic,
  AnalysisCreateContainerEpic as default,
  getSampleForayJobConfigEpic,
  getSegmentsEpic,
  uploadSupportFilesEpic,
  validateForayJobConfigEpic
};
//# sourceMappingURL=AnalysisCreateContainer.epics.js.map
